import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme) => ({
  body: {
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    fontFamily: theme.design.typography.fontFamily,
    justifyContent: "center",

    backgroundSize: "auto 100%",
    backgroundPosition: "100%",

    maxWidth: "1920px",
    margin: "auto",
    boxSizing: "border-box",
    width: "100%",

    [theme.breakpoints.down("md")]: {
      padding: "16px 16px",
    },
  },

  container: {
    gap: "48px",
    display: "flex",
    width: 920,
    margin: "auto",
    marginBottom: 16,
    marginTop: 16,

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      marginBottom: 16,
      marginTop: 16,
      width: "100%",
    },
    position: "relative",
  },

  inventoryCard: {
    width: "100%",
    minHeight: "420px",

    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    height: "360px",
    padding: "24px 32px",
    gap: "32px",
    justifyContent: "flex-start",
    backgroundColor: theme.design.color.surface.container,
    border: "1px solid",
    borderColor: theme.design.color.border.default,
    boxShadow:
      theme.design.shadow.lg,

    boxSizing: "border-box",

    [theme.breakpoints.down("md")]: {
      padding: "16px 16px",
    },

    [theme.breakpoints.down("sm")]: {
      gap: 12,
    },
  },

  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },

  cardHeaderTitle: {
    color: theme.design.color.text.primary,
    fontFamily: theme.design.typography.fontFamily,
    fontSize: 20,
    fontWeight: 900,

    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      fontSize: 16,
    },
  },

  cardHeaderWorth: {
    color: theme.design.color.text.secondary,
    fontFamily: theme.design.typography.fontFamily,
    fontSize: 14,
    fontWeight: 900,
    whiteSpace: "nowrap",

    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      fontSize: 12,
    },
  },

  playerNameLabel: {
    color: theme.design.color.text.secondary,
    fontFamily: theme.design.typography.fontFamily,
    fontSize: 12,
    fontWeight: 900,
    whiteSpace: "nowrap",
    width: "100%",
    textAlign: "center",
  },

  cardList: {
    display: "grid",
    gap: 16,
    padding: 8,
    gridTemplateColumns: "repeat(auto-fill, minmax(66px, 1fr))",
    overflowY: "scroll",
  },

  inventoryItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
  },

  inventoryItemBox: {
    // padding: "4px 8px",
    borderRadius: 8,
    border: "1px solid",
    borderColor: theme.design.color.border.default,

    background: theme.design.color.surface.container,
    boxShadow:
      theme.design.shadow.inset,

    transition: "300ms",
    cursor: "pointer",

    "&:hover": {
      filter: "brightness(1.5)",
      transform: "scale(1.2)",
    },
    height: 60,
    clipPath: "border-box",
    display: "flex",
    alignItems: "center",
  },

  inventoryItemIcon: {
    width: 60,
    height: 60,
    objectFit: "contain",
  },

  slotItemIcon: {
    width: 60,
    height: "auto",
    
  },

  inventoryCrateIcon: {},

  inventoryOGIcon: {
    height: 60,
  },

  inventoryMafiaIcon: {
    padding: 8,
    boxSizing: "border-box",
  },

  inventoryItemName: {
    color: theme.design.color.text.secondary,
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    fontSize: 12,

    userSelect: "none",
    textAlign: "center",
  },

  cardHeaderBadgeDanger: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 12,
    color: theme.design.color.status.danger,
    fontWeight: 900,
  },

  cardHeaderBadgeSafe: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontSize: 12,
    color: theme.design.color.status.success,
    fontWeight: 900,
  },

  private: {
    filter: "blur(15px)",
    pointerEvents: "none",
  },

  confirmButton: {
    backgroundColor: theme.design.color.action.primary,
    display: "flex",
    alignItems: "normal",
    gap: "8px",
    padding: "0px 12px",
    textTransform: "none",
    borderRadius: "8px",
    fontFamily: theme.design.typography.fontFamily,
    fontWeight: 900,
    minWidth: 60,
    fontSize: 12,
    color: theme.design.color.text.primary,
  },

  inputBox: {
    borderRadius: "12px",
    boxSizing: "border-box",
    padding: "0px 8px",
    backgroundColor: theme.design.color.border.black,
    color: theme.design.color.text.primary,
    outline: "none",

    "& input": {
      outline: "none!important",
      border: "none",
      color: theme.design.color.text.primary,
      fontFamily: theme.design.typography.fontFamily,
      fontSize: "12px",
      fontWeight: 900,

      "&::placeholder": {
        color: theme.design.color.text.secondary,
      },
    },

    "& .MuiTextField-root::after": {
      content: "initial",
    },
  },
}));

export default styles;
